import React from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';

import SearchIcon from 'assets/SearchIcon';
import TranslateProperty from 'components/TranslateProperty';

const styles = {
  wrapper: {
    margin: '0',
    height: '50px',
    width: '200px',
    position: 'relative',
    paddingLeft: '50px',
    backgroundColor: '#F2F5FC',
    border: '1px solid #E0E0E0',
    borderRadius: '10px'
  },
  input: {
    height: '100%',
    width: '95%',
    alignItems: 'center',
    background: 'transparent',
    border: 'none',
  },
  icon: {
    position: 'absolute',
    height: '100%',
    width: '50px',
    left: 0,
    top: '0',
  },
};

const SearchBar = (props) => {
  const {
    searchString, handleSearch, id, wrapperStyles, inputStyles,
  } = props;

  return (
    <div style={[styles.wrapper, wrapperStyles]}>
      <TranslateProperty
        properties={[{ key: 'placeholder', value: 'search' }]}
      >
        <input
          style={[styles.input, inputStyles]}
          id={id}
          value={searchString}
          onChange={(event) => {
            handleSearch(event.target.value);
          }}
        />
      </TranslateProperty>
      <div className="centered-flex-container" style={styles.icon}>
        <SearchIcon width="22" height="22" />
      </div>
    </div>
  );
};

SearchBar.propTypes = {
  id: PropTypes.string.isRequired,
  handleSearch: PropTypes.func.isRequired,
  searchString: PropTypes.string.isRequired,
  wrapperStyles: PropTypes.object,
  inputStyles: PropTypes.object,
};

SearchBar.defaultProps = {
  wrapperStyles: {},
  inputStyles: {},
};

export default Radium(SearchBar);



// WEBPACK FOOTER //
// ./src/components/SearchBar.jsx